
import { GetSidebarByUserResponse } from '@/api/dtos';
import SidebarContext from '@/contexts/data/SidebarContext';
import useSidebarByUser from '@/hooks/data/useSidebarByUser';
import { FC, PropsWithChildren } from 'react';


export interface ISidebarProviderProps {
    initial?: GetSidebarByUserResponse;
}

export const SidebarProvider: FC<PropsWithChildren<ISidebarProviderProps>> = ({ initial, children }) => {
    const sideBar = useSidebarByUser({ revalidateOnFocus: false, fallbackData: initial});

    return (
        <SidebarContext.Provider value={sideBar}>
            {children}
        </SidebarContext.Provider>
    );
}

export default SidebarProvider;
